// OrtoSoft — phone number, assembled at runtime.
// The full number never appears as a single literal in the HTML source or the
// JS bundle, so scrapers regexing the page or the bundle can't harvest it.
// The tel: link is built from the same parts, so tapping still dials.
// (A link that works must carry its target in the live DOM — that is the
// accepted trade-off; what we block is source-level scraping.)

const PARTS = ['33', '6', '79', '21', '76', '72'];

export const PHONE_DISPLAY = '+' + PARTS.join(' '); // +33 6 79 21 76 72
export const PHONE_TEL = '+' + PARTS.join(''); // +33679217672
export const telHref = 'tel:' + PHONE_TEL;
// wa.me wants the digits only, without the leading '+'.
export const waHref = 'https://wa.me/' + PARTS.join('');
